export const STUDENT = 'student'

export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

export const GRADE_LEVELS = ['Pre-K', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

export const TITLE_OPTIONS = ['Mr.', 'Ms.', 'Mrs.']

export const ADDRESS_CHANGE_STATUS_COLORS = {
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
  cancelled: 'default',
}

export const SUFFIX_OPTIONS = [
  { label: 'Jr', value: 'Jr' },
  { label: 'I', value: 'I' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' }
];

export const USER_TYPE_OPTIONS = [
  { value: 'student', label: 'Student' },
  { value: 'staff', label: 'Staff' },
  { value: 'parent', label: 'Parent' },
]

export const PHONE_TYPE_OPTIONS = [
  { label: 'Mobile', value: 'mobile' },
  { label: 'Home', value: 'home' }
];

export const INCIDENT_TYPE_OPTIONS = [
  { value: 'merit', label: 'Merit' },
  { value: 'demerit', label: 'Demerit' },
];

export const NOTIFICATION_CHANNEL_OPTIONS = [
  { value: 'email', label: 'Email' },
  { value: 'sms', label: 'SMS' },
];

export const NOTIFICATION_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'delivery', label: 'Delivery' },
  { value: 'failed', label: 'Failed' },
];

export const NOTIFICATION_EVENT_GROUPS = {
  email: {
    pending: ['Send'],
    delivery: ['Delivery', 'Open', 'Click', 'Subscription'],
    failed: ['Bounce', 'Complaint', 'DeliveryDelay', 'Reject', 'RenderingFailure', 'Send.Failure'],
  },
  sms: {
    pending: ['TEXT_QUEUED', 'TEXT_PENDING'],
    delivery: ['TEXT_DELIVERED', 'TEXT_SUCCESSFUL'],
    failed: [
      'TEXT_BLOCKED',
      'TEXT_TTL_EXPIRED',
      'TEXT_CARRIER_UNREACHABLE',
      'TEXT_INVALID',
      'TEXT_INVALID_MESSAGE',
      'TEXT_CARRIER_BLOCKED',
      'TEXT_UNREACHABLE',
      'TEXT_SPAM',
      'TEXT_UNKNOWN',
      'TEXT_PROTECT_BLOCKED',
    ],
  },
};

export const ALL_CAMPUSES = 0;
